module.exports = __webpack_public_path__ + "img/2_top1_1.33e919a6.png";